import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UserIcon } from 'lucide-react';
export function CreatorSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-6 md:py-10 px-6" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-74">
          <div className="text-center mb-6" data-id="element-75">
            <div className="w-28 h-28 rounded-full bg-cream border-2 border-rose/20 mx-auto mb-4 overflow-hidden" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/3pojCppQATnoi2MGMnNPR7/WhatsApp_Image_2026-05-01_at_18.56.15.jpg" alt="Paul Ocampo" className="w-full h-full object-cover" data-id="element-77" />
            </div>
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-brown" data-id="element-78">
              Paul Ocampo
            </h2>
            <p className="font-sans text-base text-rose font-medium" data-id="element-79">
              Creador del Método
            </p>
          </div>

          <div className="bg-cream/50 rounded-3xl p-6 md:p-8 border border-rose/10 space-y-4" data-id="element-80">
            <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-81">
              Durante 8 años, la misma pregunta silenciosa regresaba cada mes:{' '}
              <em data-id="element-82">¿Será este mes?</em>
            </p>

            <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-83">
              Intentaba que no me afectara. Construía una coraza. Pero por
              dentro había una tormenta constante — esa sensación de no poder
              entender por qué la vida no llegaba, sin importar cuánto la
              deseáramos.
            </p>

            <p className="font-sans text-base text-brown/90 leading-relaxed font-medium" data-id="element-84">
              Hasta que algo dentro de mí me susurró que la respuesta no estaba
              en los médicos. Estaba en el árbol.
            </p>

            <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-85">
              Empecé a investigar mi linaje. A través de meditaciones profundas
              descubrí algo que nadie me había dicho: había un arrebato — un
              bebé que fue arrancado de mi árbol familiar. Una vida que no pudo
              ser. Y ese dolor sin nombre, ese duelo sin funeral, se había
              convertido en una lealtad invisible: si ellos no pudieron dar
              vida, yo tampoco tenía permiso.
            </p>

            <p className="font-sans text-base text-brown/90 leading-relaxed font-semibold" data-id="element-86">
              No era un problema de biología. Era una deuda del alma que yo
              estaba cargando sin saberlo.
            </p>

            <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-87">
              Cuando finalmente reconocí a ese ancestro desplazado, cuando honré
              su historia y le devolví su lugar en el árbol, algo se movió. El
              nudo se soltó. Y Dios, fiel a Su promesa, abrió las puertas.
            </p>

            <blockquote className="border-l-4 border-gold pl-4 py-2 my-4" data-id="element-88">
              <p className="font-serif text-base md:text-lg text-brown/80 italic leading-relaxed" data-id="element-89">
                "Si dos de vosotros se pusieren de acuerdo en la tierra acerca
                de cualquiera cosa que pidieren, les será hecho por mi Padre que
                está en los cielos."
              </p>
              <cite className="font-sans text-sm text-gold font-medium not-italic" data-id="element-90">
                — Mateo 18:19
              </cite>
            </blockquote>

            <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-91">
              Creé este método para que tú no tardes 8 años en encontrar lo que
              yo encontré. Está diseñado para mujeres — pero también para los
              hombres que acompañan, porque la vida nueva entra cuando dos están
              en orden.
            </p>

            <p className="font-sans text-base text-brown font-semibold leading-relaxed" data-id="element-92">
              Si sientes que hay algo más detrás de tu espera, tienes razón. Y
              este es el camino.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}